import type { TextareaHTMLAttributes } from "react";
import { cn } from "./utils";

type AdminControlTone = "default" | "warning" | "info";

interface AdminTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  tone?: AdminControlTone;
}

const toneClass: Record<AdminControlTone, string> = {
  default: "border-slate-200 focus:border-blue-500 focus:ring-blue-500",
  warning: "border-amber-200 focus:border-amber-500 focus:ring-amber-500",
  info: "border-blue-200 focus:border-blue-500 focus:ring-blue-500",
};

const AdminTextarea = ({ tone = "default", className, ...props }: AdminTextareaProps) => (
  <textarea
    className={cn(
      "w-full resize-none rounded-lg border bg-white p-2.5 text-xs text-slate-700 outline-none transition-colors placeholder:text-slate-400 focus:ring-1 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400",
      toneClass[tone],
      className,
    )}
    {...props}
  />
);

export default AdminTextarea;
